import { useEffect } from 'react';
import Router from './routes/router';
import GlobalLoader from './components/GlobalLoader';

function App() {

  useEffect(() => {
    const loader = document.getElementById("initial-loader");

    if (loader) {
      loader.style.transition = "opacity .25s ease";
      loader.style.opacity = "0";

      setTimeout(() => loader.remove(), 250);
    }
  }, []);


  return <>
   <GlobalLoader />
  
  <Router />
  </>
}

export default App;